import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, TrendingUp, Shield } from 'lucide-react';
const cards = [{
  icon: Briefcase,
  title: 'Entrepreneurs & Business Owners',
  description: "You built something impressive. But behind closed doors, you're running on anxiety, numbing out, and wondering if this is really it."
}, {
  icon: TrendingUp,
  title: 'Sales Professionals',
  description: "You crush your numbers. But you're running on fumes, caffeine, and coping mechanisms that are starting to crack."
}, {
  icon: Shield,
  title: 'High Achievers in Recovery',
  description: "You got sober — or you're ready to. Now you need to rebuild your identity, your relationships, and your purpose from the ground up."
}];
export function WhoIHelp() {
  return <section id="who-i-help" className="py-24 bg-charcoal relative" data-id="element-172">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-174">
          <h2 className="font-heading text-4xl md:text-5xl text-white mb-4" data-id="element-175">
            Who I Help
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto" data-id="element-176"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-177">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="group bg-dark p-8 border border-dark-lighter hover:border-gold/50 transition-all duration-300 rounded-sm relative overflow-hidden" data-id="element-178">
              <div className="absolute top-0 left-0 w-full h-1 bg-gold transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" data-id="element-179"></div>

              <div className="mb-6 inline-flex items-center justify-center w-14 h-14 rounded-full bg-dark-darker border border-dark-lighter group-hover:border-gold/30 transition-colors" data-id="element-180">
                <card.icon className="text-gold w-7 h-7" data-id="element-181" />
              </div>

              <h3 className="font-heading text-2xl text-white mb-4 group-hover:text-gold transition-colors" data-id="element-182">
                {card.title}
              </h3>

              <p className="text-gray-400 leading-relaxed" data-id="element-183">
                {card.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}